import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import RubriqAbstractCardStatus from './RubriqAbstractCardStatus';
import RubriqAbstractCardActions from './RubriqAbstractCardActions';
var RubriqAbstractCard = function RubriqAbstractCard(_ref) {
  var abstract = _ref.abstract;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-md-row align-items-md-start gap-2 border p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 d-flex flex-column gap-1",
    style: {
      minWidth: '0'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2",
    style: {
      minWidth: '0'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-square-list"
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5 text-truncate"
  }, abstract.title)), /*#__PURE__*/React.createElement("div", {
    className: "ms-2",
    style: {
      paddingLeft: '11.25px' /* skip icon width */
    }
  }, /*#__PURE__*/React.createElement(RubriqAbstractCardStatus, {
    abstract: abstract
  }))), /*#__PURE__*/React.createElement(RubriqAbstractCardActions, {
    abstract: abstract
  }));
};
export default RubriqAbstractCard;